import Vault from "../../helpers/Vault";
import { useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { check } from "../../helpers/Request";
import "./styles.scss";
import { APP_NAME } from "../../constants/app-name";
import { GoogleLoginButton } from "./google-login-button";
const vault = Vault.getInstance();

export function Unlock() {
  const pwdRef = useRef();
  const btnRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  const unlockHandler = (ev) => {
    ev.preventDefault();
    const pwd = pwdRef.current.value;

    fetch("/api/vault/unlock", {
      method: "POST",
      body: JSON.stringify({ password: pwd }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        }
        alert("Contraseña incorrecta.");
      })
      .then((data) => {
        if (data) {
          vault.setItem("session", data.session);
          localStorage.setItem("session", data.session);
          const search = new URLSearchParams(location.search?.slice(1));
          const r = search.get("r");
          if (r) {
            return navigate(atob(r));
          }
          navigate("/");
        }
      })
      .catch((_) => {
        console.log(_);
        alert("Ha ocurrido un error al intentar desbloquear la aplicación.");
      });
  };

  useEffect(() => {
    check().then((value) => {
      if (value) {
        const search = new URLSearchParams(location.search?.slice(1));
        const r = search.get("r");
        if (r) {
          navigate(atob(r), { replace: true });
          return null;
        }
        navigate("/", { replace: true });
      }
    });
    //eslint-disable-next-line
  }, []);

  return (
    <div className="unlock-container">
      <h1 className="application-name">{APP_NAME}</h1>
      <p>Donde cada plato lleva una historia romántica y mucho amor.</p>
      <div className="g-signin2" data-onsuccess="onSignIn"></div>
      <GoogleLoginButton />
    </div>
  );
}
